exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".TestButton-module__test___3Tae-{position:absolute;z-index:10;bottom:1rem;left:1rem;color:#fff}.TestButton-module__test___3Tae- a{display:grid;grid-template-columns:auto auto;gap:.5rem;align-items:center;font-size:17px}", ""]);

// exports
exports.locals = {
	"test": "TestButton-module__test___3Tae-"
};